import { ValidationRuleDefinitionDTO } from "../DTO/validationRuleDefinitionDTO";

export class ValidationRuleDefinition{
    public id!: number;
    public name!: string;
    public description!: string;
    public inputDataType!: string;
    public parameterCount!: number;
    public parameterLabels!: string;

    public static mapFromDTO(param:ValidationRuleDefinitionDTO):ValidationRuleDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ValidationRuleDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.inputDataType = param.inputDataType;
            obj.parameterCount = param.parameterCount;
            obj.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ValidationRuleDefinition):ValidationRuleDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ValidationRuleDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.inputDataType = param.inputDataType;
            dto.parameterCount = param.parameterCount;
            dto.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public getParameterLabel(index:number):{label:string, maxLength:number} | undefined {
        if(this.parameterLabels){
            let labelArray = this.parameterLabels.split(',');
            if(index < labelArray.length){
                let labelItemArray=labelArray[index].split(':');
                let maxLength= (labelItemArray.length>1)?labelItemArray[1]:1024;
                return {label:labelItemArray[0], maxLength:isNaN(Number(maxLength))?1024:Number(maxLength)}; //our default maxLength for Parameters is 1024
            }
            else return undefined;
        }
        else return undefined;
    }
}